<template>
  <div class="h-full">
    <PriorityList
      :selected="type === 'single' ? internalState[0] : internalState"
      :type="type"
      @update:selected="handleChange"
    />
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { isEqual, sortBy } from "lodash";
import { PriorityList } from "@/Components/Priority";

const emit = defineEmits(["apply", "isLoaded"]);

const props = defineProps({
  initialState: { type: Array, default: () => [] },
  type: {
    type: String,
    validator: (val) => ["single", "multiple"].includes(val),
    default: "multiple",
  },
});

const internalState = ref([...props.initialState]);

const disableApply = computed(() => {
  if (internalState.value.length < 1) {
    return true;
  }
  return isEqual(sortBy(props.initialState), sortBy(internalState.value));
});

onMounted(() => {
  emit("isLoaded");
});

function handleChange(selected) {
  if (selected && props.type === "single") {
    internalState.value[0] = selected;
  } else {
    internalState.value = selected || [];
  }
}

function handleApply() {
  emit(
    "apply",
    internalState.value && props.type === "single"
      ? internalState.value[0]
      : internalState.value
  );
}

defineExpose({
  showBack: false,
  showApply: true,
  showSearch: false,
  disableApply,
  handleBack: () => {},
  handleApply,
});
</script>
